import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAllocateService,
  Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto,
} from '../../services/wealthlane-award-services';

const useGetPendingDrsRegistrationShareDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto | undefined,
  unknown
> => {
  const getPendingDrsRegistrationShareDetails = useQuery(
    ['getPendingDrsRegistrationShareDetails'],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocatePendingTransferAllocatesShareDetailForDrs(
          id
        )
      );
    }
  );

  return getPendingDrsRegistrationShareDetails;
};

export default useGetPendingDrsRegistrationShareDetails;
